import notify from "./notify/zhCN";

export default {
    notify: notify
}
